__turbopack_context__.v({
  "banner": "OperationalDestinationBanner-module__mu47Dq__banner",
  "content": "OperationalDestinationBanner-module__mu47Dq__content",
  "cta": "OperationalDestinationBanner-module__mu47Dq__cta",
  "message": "OperationalDestinationBanner-module__mu47Dq__message",
  "pill": "OperationalDestinationBanner-module__mu47Dq__pill",
  "pillDot": "OperationalDestinationBanner-module__mu47Dq__pillDot",
  "title": "OperationalDestinationBanner-module__mu47Dq__title",
});
